import {useEffect, useRef, useState} from "react";
import ShowAdministrativeGraphics from "./show-administrative-graphics";

const PanelRightAdministrative = (props) => {
    const [optionSelected, setOptionSelected] = useState("");
    const [isOptionOpen, setIsOptionOpen] = useState(false);
    const menuRef = useRef(null);
    const [hasScroll, setHasScroll] = useState(false);

    const data = [
        {id: 1, name: "Selecciona la estadística a visualizar", valor: ""},
        {id: 2, name: "Consumo de planes", valor: "consumption"},
        {id: 3, name: "Facturación", valor: "billing"},
        {id: 4, name: "Servicios", valor: "services"},
        {id: 5, name: "Horarios con mayor demanda", valor: "schedule"},
        {id: 6, name: "Ingreso de usuarios", valor: "user_joined"},
        {id: 7, name: "Retiro de usuarios", valor: "user_left"},
        {id: 8, name: "Consumo por sexo", valor: "consumption_gender"},
        {id: 9, name: "Estadística por edad", valor: "age"},
        {id: 10, name: "Métodos de pago", valor: "payment_method"},
    ];

    useEffect(() => {
        if (menuRef.current) {
            setHasScroll(menuRef.current.scrollHeight > menuRef.current.clientHeight);
        }
    }, [data]);

    return (
        <div
            style={{
                width: "60%",
                border: "1px solid #B6C1CE",
                borderRadius: "10px",
                height: "100%",
            }}
        >
            <div className="h-100">
                <div>
                    <div
                        className="d-flex p-2 pt-4 pb-3 h-auto"
                        style={{justifyContent: "center"}}
                    >
                        <span
                            style={{
                                fontSize: "calc(.4rem + .4vw)",
                                color: "var(--elevvaTextTitle)",
                            }}
                        >
                          <strong>Estadísticas</strong>
                        </span>
                    </div>

                    <div className="d-flex mx-auto h-auto align-items-center justify-content-center">
                        <div className="dropdown text-center position-relative">
                            <button
                                className="btn dropdown-toggle card-select graphics d-flex justify-content-between align-items-center"
                                type="button"
                                id="optionDropdown"
                                aria-expanded={isOptionOpen}
                                onClick={() => setIsOptionOpen(!isOptionOpen)}
                            >
                                <span>
                                  {optionSelected === ""
                                      ? "Selecciona la estadística"
                                      : data.find((opt) => opt.valor === optionSelected)?.name}
                                </span>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: `<svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.26912 8.89571C6.91484 8.89571 6.56051 8.76057 6.29014 8.49022L0.925015 3.12509C0.38437 2.58444 0.38437 1.70785 0.925015 1.16719C1.46564 0.62656 2.34226 0.62656 2.88289 1.16719L7.26912 5.55347L11.6553 1.16719C12.196 0.62656 13.0726 0.62656 13.6132 1.16719C14.1539 1.70785 14.1539 2.58444 13.6132 3.12509L8.2481 8.49022C7.97775 8.76057 7.6234 8.89571 7.26912 8.89571Z" fill="#9DACBD"/></svg>`,
                                    }}
                                />
                            </button>
                            <ul
                                ref={menuRef}
                                className={`dropdown-menu w-100 card-select-menu p-2 ${
                                    hasScroll ? "pe-0" : ""
                                } ${isOptionOpen ? "show" : ""}`}
                                aria-labelledby="optionDropdown"
                            >
                                {data.map((opt) => (
                                    <li
                                        key={opt.id}
                                        className={`card-select-label dropdown-item ${
                                            optionSelected === opt.valor ? "active" : ""
                                        }`}
                                        onClick={() => {
                                            setOptionSelected(opt.valor);
                                            setIsOptionOpen(false);
                                        }}
                                        style={{cursor: "pointer"}}
                                    >
                                        {opt.name}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <hr style={{width: "70%"}} className=" mx-auto"></hr>
                </div>

                <div>
                    <ShowAdministrativeGraphics optionSelected={optionSelected}/>
                </div>
            </div>
        </div>
    );
};

export default PanelRightAdministrative;
